import { useTranslation } from 'react-i18next';
import Link from '@sportson/core-web/components/Link';
import styled from 'libs/styled';
import Text from 'components/Text';
import useAppSelector from '@sportson/core-web/hooks/useAppSelector';

const Wrapper = styled('div')`
    display: none;
`;

const Heading = styled('div')`
    display: flex;
    align-items: center;
    height: 56px;
`;

const VariantList = styled('ul')`
    list-style-position: outside;
    margin-left: 0;
    padding-left: 40px;

    margin-top: 0.5em;
    list-style-type: unset;

    span > * + * {
        margin-top: 0em !important;
    }
`;

const VariantListItem = styled('li')`
    position: relative;
`;

const VariantLinks = ({ variants, mainProduct, onVariantChange }) => {
    const { t } = useTranslation();

    const mainProductUrl = mainProduct?.url;
    const mainProductId = mainProduct?.id;

    return (
        <Wrapper>
            <Heading>
                <Text as="h2" typography="UI/20_100_0_450">
                    {t('pdp.info.other_variants')}
                </Text>
            </Heading>
            <VariantList>
                <Text as="span" typography="Content/18_150_0_350">
                    {variants?.map((productVariant) => {
                        const productLink = `${mainProductUrl}?p=${productVariant.partNo}`;

                        return (
                            <VariantListItem key={productVariant.partNo}>
                                <Link to={productLink} onClick={() => onVariantChange(mainProductId, productVariant)}>
                                    {productVariant.name}
                                </Link>
                            </VariantListItem>
                        );
                    })}
                </Text>
            </VariantList>
        </Wrapper>
    );
};

export default VariantLinks;
